/* Asteria V25 — navigate from Retail to Wholesale in one click. */
(() => {
  'use strict';
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-ae-wholesale-nav]');
    if (!link) return;
    event.preventDefault();
    if (link.dataset.aeBusy === 'true') return;
    link.dataset.aeBusy = 'true';
    link.setAttribute('aria-busy', 'true');
    const previous = link.style.opacity;
    link.style.opacity = '0.7';
    try {
      const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
      const cartUrl = root.replace(/\/$/, '') + '/cart/update.js';
      const response = await fetch(cartUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { ae_shopping_mode: 'wholesale' } })
      });
      if (!response.ok) throw new Error('wholesale-mode-update-failed');
      const cart = await response.json();
      if (cart.attributes?.ae_shopping_mode !== 'wholesale')
        throw new Error('wholesale-mode-not-confirmed');
      try { sessionStorage.setItem('ae_global_entry_choice', 'wholesale'); } catch (_) {}
      // Enter the translated wholesale access page, keeping this theme preview.
      const destination = new URL(link.href, window.location.origin);
      const preserved = window.AEPreviewContext?.withPreviewContext(destination.href);
      if (preserved) { destination.search = preserved.search; destination.hash = preserved.hash; }
      window.location.assign(destination.href);
    } catch (_) {
      // Do not display unlocked retail pricing under a falsely selected
      // wholesale mode. Offer the existing entry choice screen instead.
      const fallback = new URL(link.href, window.location.origin);
      const preserved = window.AEPreviewContext?.withPreviewContext(fallback.href);
      if (preserved) { fallback.search = preserved.search; fallback.hash = preserved.hash; }
      link.dataset.aeBusy = 'false';
      link.removeAttribute('aria-busy');
      link.style.opacity = previous;
      window.location.assign(fallback.href);
    }
  });
})();
